// زر عائم لكتم/تشغيل صوت الترحيب (وأي صوت مستقبلي في الموقع).
// يحفظ الاختيار في sessionStorage.
import React, { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

const KEY = "rush_audio_muted";

const AudioToggle = () => {
  const [muted, setMuted] = useState(false);

  useEffect(() => {
    try {
      setMuted(sessionStorage.getItem(KEY) === "1");
    } catch {}
  }, []);

  const toggle = () => {
    const next = !muted;
    setMuted(next);
    try {
      sessionStorage.setItem(KEY, next ? "1" : "0");
    } catch {}
    // نمرّر التغيير عبر حدث عام للاستخدام في مكونات صوتية أخرى
    window.dispatchEvent(new CustomEvent("rush:audio-muted-change", { detail: { muted: next } }));
  };

  return (
    <button
      type="button"
      data-testid="audio-toggle"
      onClick={toggle}
      aria-label={muted ? "تشغيل الصوت" : "كتم الصوت"}
      title={muted ? "تشغيل الصوت" : "كتم الصوت"}
      className="fixed bottom-6 left-6 z-[60] w-11 h-11 rounded-full bg-[#0A1128]/85 backdrop-blur-md border border-[#C9A96A]/30 text-[#E5CB94] hover:border-[#C9A96A]/60 hover:text-[#F5EAC9] transition-colors shadow-lg flex items-center justify-center"
    >
      {muted ? <VolumeX className="w-4 h-4" /> : <Volume2 className="w-4 h-4" />}
    </button>
  );
};

export default AudioToggle;
